import {mapScriptLoaderOptions} from '../constants/map.constants';

export class GoogleApiLoader {
    static scriptId: string = 'google-maps-api-script';
    private static callbackName: string = 'googleMapsApiLoadedCallback';

    public static async loadScript(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (window.google && window.google.maps) {
                resolve(window.google);
                return;
            }

            let scriptElement: HTMLScriptElement | null = document.getElementById(this.scriptId) as HTMLScriptElement;
            if (scriptElement) {
                (window as any)[this.callbackName] = () => {
                    resolve(window.google);
                };
                return;
            }

            scriptElement = document.createElement('script');
            scriptElement.id = this.scriptId;
            scriptElement.async = true;
            scriptElement.defer = true;

            (window as any)[this.callbackName] = () => {
                delete (window as any)[this.callbackName];
                resolve(window.google);
            };

            scriptElement.addEventListener('error', (error) => {
                delete (window as any)[this.callbackName];
                console.error(error.message);
                reject(error);
            });

            scriptElement.src = this.buildUrl();
            document.head.appendChild(scriptElement);
        });
    }

    private static buildUrl(): string {
        const url = new URL(mapScriptLoaderOptions.url || process.env.REACT_APP_MAP_URL);

        url.searchParams.append('key', process.env.REACT_APP_MAP_API_KEY || '');
        if (mapScriptLoaderOptions.client) url.searchParams.append('client', mapScriptLoaderOptions.client);
        if (mapScriptLoaderOptions.libraries) url.searchParams.append('libraries', mapScriptLoaderOptions.libraries);
        url.searchParams.append('callback', this.callbackName);
        url.searchParams.append('loading', 'async');
        return url.toString();
    }
}
